import './App.css';
import { lazy, Suspense } from 'react';
import { ThemeProvider, LanguageProvider, ViewProvider, CustomizationProvider } from './contexts';
import { ToastProvider, ToastContainer } from './components/Toast';
import CustomizationPanel from './components/CustomizationPanel';
import Hero from './components/Hero';
import DotBackground from './components/DotBackground';

const Header = lazy(() => import('./components/Header'));
const Projects = lazy(() => import('./components/Projects'));
const Certificates = lazy(() => import('./components/Certificates'));
const SocialCards = lazy(() => import('./components/SocialCards'));
const GmailCompose = lazy(() => import('./components/GmailCompose/GmailCompose'));
const Footer = lazy(() => import('./components/Footer'));
const Footer2 = lazy(() => import('./components/Footer2'));
const Services = lazy(() => import('./components/Services'));
const About = lazy(() => import('./components/About'));
const FawAi = lazy(() => import('./components/FawAi'));
const Experience = lazy(() => import('./components/Experience'));
const Skills = lazy(() => import('./components/Skills'));
const ScrollToTop = lazy(() => import('./components/ScrollToTop'));

function App() {
  return (
    <CustomizationProvider>
      <ThemeProvider>
        <LanguageProvider>
          <ViewProvider>
            <ToastProvider>
              <div className="App">
                <DotBackground />
                <Suspense fallback={<div></div>}>
                  <Header />
                  <Hero />
                  <About />
                  <Projects />
                  <Skills />
                  <Experience />
                  <Services />
                  <Certificates />
                  <SocialCards />
                  <GmailCompose />
                  <CustomizationPanel />
                  {/* <Footer /> */}
                  <Footer2 />
                  <FawAi />
                  <ScrollToTop />
                </Suspense>
                <ToastContainer />
              </div>
            </ToastProvider>
          </ViewProvider>
        </LanguageProvider>
      </ThemeProvider>
    </CustomizationProvider>
  );
}

export default App;
